<template>
  <v-container class="list-product-section step">
    <v-row justify="center">
      <v-col sm="3">
        <v-card
        variant="outline"
        data-aos="fade-right"
        data-aos-delay="0"
        data-aos-duration="2000"
        data-aos-mirror="true"
        data-aos-once="false"
        class=" pro-card"
        >
        <a href="#lotion-section">
            <v-img
              class="pro-card-img"
              :src="baseUrl + '/media/image/renb_pic7.png'"
            ></v-img>
            <v-card-title class="text-h6">
              <p class="pro-name">Re.NB PURE RADIANT REVIVAL LOTION</p>
              <p class="pro-cate">{{$t("_lst_txt_1")}}</p>
              <p class="pro-type">{{$t("_lst_txt_2")}}</p>
            </v-card-title>
        </a>
        </v-card>
      </v-col>
      <v-col sm="3">
        <v-card variant="outline"
          data-aos="fade-down"
          data-aos-delay="0"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
          class=" pro-card"
        >
        <a href="#emulsion-section">
            <v-img
              class="pro-card-img"
              :src="baseUrl + '/media/image/renb_pic9.png'"
            ></v-img>
            <v-card-title class="text-h6">
              <p class="pro-name">Re.NB PURE RADIANT REVIVAL EMULSION</p>
              <p class="pro-cate">{{$t("_lst_txt_3")}}</p>
              <p class="pro-type">{{$t("_lst_txt_4")}}</p>
            </v-card-title>
        </a>
        </v-card>
      </v-col>
      <v-col sm="3">
        <v-card variant="outline"
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="2000"
        data-aos-mirror="true"
        data-aos-once="false"
        class=" pro-card"
        >
        <a href="#serum-section">
            <v-img
              class="pro-card-img"
              :src="baseUrl + '/media/image/renb_pic11.png'"
            ></v-img>
            <v-card-title class="text-h6">
              <p class="pro-name">Re.NB PURE RADIANT REVIVAL SERUM</p>
              <p class="pro-cate">{{$t("_lst_txt_5")}}</p>
              <p class="pro-type">{{$t("_lst_txt_6")}}</p>
            </v-card-title>
        </a>
        </v-card>
      </v-col>
      <v-col sm="3">
        <v-card variant="outline"
          data-aos="fade-left"
          data-aos-delay="0"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
          class=" pro-card"
        >
          <a href="#cream-section">
            <v-img
              class="pro-card-img"
              :src="baseUrl + '/media/image/renb_pic13.png'"
            ></v-img>
            <v-card-title class="text-h6">
              <p class="pro-name">Re.NB PURE RADIANT REVIVAL CREAM</p>
              <p class="pro-cate">{{$t("_lst_txt_7")}}</p>
              <p class="pro-type">{{$t("_lst_txt_8")}}</p>
            </v-card-title>
          </a>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style>
.pro-card-img {
  height: 350px;
  cursor: pointer;
}
.text-h6 {
  text-align: center;
}
.pro-name {
  font-family: "BodoniModa-Bold";
  font-size: 10px;
}
.pro-cate {
  text-align: center;
  font-family: 'ZenKakuMedium';
}
.pro-type {
  font-size: 12px;
}
.pro-card:hover {
  transform: translateY(-20px)!important;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}
.pro-card {
  transition: transform 0.1s ease-out;
}

</style>